import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

const PaymentCancelPage = () => {
  return (
    <main data-testid="payment-cancel-page" className="pt-20">
      <section className="py-24 md:py-32 min-h-[70vh] flex items-center justify-center">
        <div className="max-w-lg mx-auto px-6 text-center">
          <div
            className="w-20 h-20 rounded-full mx-auto flex items-center justify-center mb-8"
            style={{ background: "var(--ll-bg-secondary)" }}
          >
            <XCircle size={40} style={{ color: "var(--ll-text-muted)" }} />
          </div>

          <h1
            className="font-serif text-3xl sm:text-4xl font-light mb-4"
            style={{ color: "var(--ll-text)" }}
          >
            Payment Cancelled
          </h1>
          <p
            className="text-base leading-relaxed mb-8"
            style={{ color: "var(--ll-text-secondary)", fontFamily: "'Outfit', sans-serif" }}
          >
            Your payment was cancelled. No charges have been made. You can always return to try again whenever you're ready.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/"
              data-testid="cancel-back-home"
              className="inline-flex rounded-full px-8 py-3.5 text-sm font-medium transition-all duration-300 hover:-translate-y-0.5"
              style={{
                background: "var(--ll-cta)",
                color: "var(--ll-cta-text)",
                fontFamily: "'Outfit', sans-serif",
              }}
            >
              Back to Home
            </Link>
            <a
              href="/#products"
              data-testid="cancel-view-products"
              className="inline-flex rounded-full px-8 py-3.5 text-sm font-medium border transition-all duration-300 hover:-translate-y-0.5"
              style={{
                borderColor: "var(--ll-border)",
                color: "var(--ll-text-secondary)",
                fontFamily: "'Outfit', sans-serif",
              }}
            >
              View Products
            </a>
          </div>
        </div>
      </section>
    </main>
  );
};

export default PaymentCancelPage;
